/**
 * 配置开发和生产环境的切换
 *高阶组件的作用
 * baseUrl：域名地址
 * routerMode：路由模式
 */

let baseUrl = 'https://szrqzb.cn/'; // 有用 生产
//  let baseUrl = 'http://192.168.15.158:10209/web/'; // 有用
//  let baseUrl = 'http://192.168.15.124:10209/web/'; // 有用
//  let baseUrl = 'http://192.168.15.226:10209/web/'; // 有用
 let cookieDomainName = "127.0.0.1"; // 有用
 let shopUrl = '';//店铺地址
 export {
   baseUrl,
   cookieDomainName,
   shopUrl
 }



// WEBPACK FOOTER //
// ./src/api/global_variable.js